
import { MessageCircle, Bell, Check, Clock, AlertCircle } from "lucide-react";
import { Badge } from "@/components/ui/badge";

interface ListingType {
  id: string;
  title: string;
  address: string;
  price: string;
  type: string;
  status: string;
  views: number;
  inquiries: number;
  image: string;
  featured: boolean;
  boosted: boolean;
  hasUnreadMessages?: boolean;
  hasUpdates?: boolean;
}

interface ListingStatusBadgesProps {
  property: ListingType;
}

const ListingStatusBadges = ({ property }: ListingStatusBadgesProps) => {
  // Get appropriate icon based on status
  const getStatusIcon = (status: string) => {
    switch(status) {
      case 'Active':
        return <Check size={12} className="text-green-600" />;
      case 'Pending':
        return <Clock size={12} className="text-amber-600" />;
      case 'Under Review':
        return <Clock size={12} className="text-amber-600" />;
      case 'Inactive':
        return <AlertCircle size={12} className="text-gray-600" />;
      default:
        return <Check size={12} />;
    }
  };

  // Get status badge color
  const getStatusBadgeStyle = (status: string) => {
    switch(status) {
      case 'Active':
        return 'bg-green-100 text-green-800 border border-green-200';
      case 'Pending':
      case 'Under Review':
        return 'bg-amber-100 text-amber-800 border border-amber-200';
      case 'Inactive':
        return 'bg-gray-100 text-gray-800 border border-gray-200';
      default:
        return 'bg-blue-100 text-blue-800 border border-blue-200';
    }
  };

  return (
    <div className="flex items-center gap-2">
      {property.hasUnreadMessages && (
        <Badge variant="destructive" className="flex items-center gap-1 px-2 py-1 rounded-full">
          <MessageCircle size={12} />
          <span className="hidden sm:inline">New Messages</span>
        </Badge>
      )}
      
      {property.hasUpdates && (
        <Badge variant="secondary" className="bg-green-100 text-green-800 border border-green-200 flex items-center gap-1 px-2 py-1 rounded-full">
          <Bell size={12} />
          <span className="hidden sm:inline">Updates</span>
        </Badge>
      )}
      
      <div className={`flex items-center gap-1 px-2 py-1 rounded-full text-xs font-medium ${getStatusBadgeStyle(property.status)}`}>
        {getStatusIcon(property.status)}
        {property.status}
      </div>
    </div>
  );
};

export default ListingStatusBadges;
